import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';

export default class extends Component{
//export class Timer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currenttime : new Date()
		};
		this.initialize = this.initialize.bind(this);
		this.interval='';
	}

	componentWillMount() {
		this.interval = setInterval(() => {
			this.setState({
				currenttime : new Date(new Date(this.state.currenttime).getTime()+1000)
			});
		}, 1000);
		this.initialize();
	}

	initialize(){
		axios.get(`/api/initialize`).then((response) => {
			if (response.data.message == 'success') {
				let currenttime = response.data.currenttime ? new Date(response.data.currenttime) : new Date();
				this.setState({
					currenttime
				});
			}
		});
	}

	render() {
		return (
			<span style={{color: "#008060"}}>{moment(this.state.currenttime).format('dddd, MMMM DD YYYY, HH:mm:ss a')}</span>
		);
	}
}


// WEBPACK FOOTER //
// ./public/react/components/timer.js